"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequisitionNoteResponseToJSON = exports.RequisitionNoteResponseFromJSONTyped = exports.RequisitionNoteResponseFromJSON = exports.instanceOfRequisitionNoteResponse = exports.RequisitionNoteResponseStateEnum = exports.RequisitionNoteResponseRequisitionStateEnum = exports.RequisitionNoteResponseCategoryEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.RequisitionNoteResponseCategoryEnum = {
    General: 'general',
    Delayed: 'delayed',
    FollowUp: 'follow_up',
    Production: 'production',
    SendOut: 'send_out',
    ReportWriting: 'report_writing'
};
/**
 * @export
 */
exports.RequisitionNoteResponseRequisitionStateEnum = {
    OrderSubmitted: 'ORDER_SUBMITTED',
    SpecimenReceived: 'SPECIMEN_RECEIVED',
    LabProcessing: 'LAB_PROCESSING',
    PreCropHold: 'PRE_CROP_HOLD',
    AnalysisAndInterpretation: 'ANALYSIS_AND_INTERPRETATION',
    PostCropHold: 'POST_CROP_HOLD',
    ReportReleased: 'REPORT_RELEASED',
    Cancelled: 'CANCELLED'
};
/**
 * @export
 */
exports.RequisitionNoteResponseStateEnum = {
    Active: 'active',
    Inactive: 'inactive'
};
/**
 * Check if a given object implements the RequisitionNoteResponse interface.
 */
function instanceOfRequisitionNoteResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfRequisitionNoteResponse = instanceOfRequisitionNoteResponse;
function RequisitionNoteResponseFromJSON(json) {
    return RequisitionNoteResponseFromJSONTyped(json, false);
}
exports.RequisitionNoteResponseFromJSON = RequisitionNoteResponseFromJSON;
function RequisitionNoteResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'dateCreated': !(0, runtime_1.exists)(json, 'dateCreated') ? undefined : json['dateCreated'],
        'dateModified': !(0, runtime_1.exists)(json, 'dateModified') ? undefined : json['dateModified'],
        'category': !(0, runtime_1.exists)(json, 'category') ? undefined : json['category'],
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'note': !(0, runtime_1.exists)(json, 'note') ? undefined : json['note'],
        'requisitionId': !(0, runtime_1.exists)(json, 'requisitionId') ? undefined : json['requisitionId'],
        'requisitionState': !(0, runtime_1.exists)(json, 'requisitionState') ? undefined : json['requisitionState'],
        'state': !(0, runtime_1.exists)(json, 'state') ? undefined : json['state'],
        'user': !(0, runtime_1.exists)(json, 'user') ? undefined : json['user'],
    };
}
exports.RequisitionNoteResponseFromJSONTyped = RequisitionNoteResponseFromJSONTyped;
function RequisitionNoteResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'dateCreated': value.dateCreated,
        'dateModified': value.dateModified,
        'category': value.category,
        'id': value.id,
        'note': value.note,
        'requisitionId': value.requisitionId,
        'requisitionState': value.requisitionState,
        'state': value.state,
        'user': value.user,
    };
}
exports.RequisitionNoteResponseToJSON = RequisitionNoteResponseToJSON;
